import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "../constants/site";

export const WhatsAppButton = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat on WhatsApp"
    data-testid="whatsapp-float-btn"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.8, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
    className="fixed bottom-6 right-6 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.4)]"
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-20" />
    <MessageCircle className="relative h-6 w-6" />
  </motion.a>
);
